let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1DFOb")).then(() => parcelRequire('dMw6u'));